import { useEffect, useReducer } from 'react'
import {
  countToStr,
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../../tools/util'
import {
  EXPORT_SELECT_ORDER_DETAIL,
  GET_ORDER_STATE_COUNT,
  GET_SUPPLIER_ORDER_PAGE,
  GET_SUPPLINER_ORDER_DETAIL,
  GET_TAB_SUPPLIER_ORDERCOUNT,
  SuppplierOrderParam,
} from '../../../api/orderManage'
import { EXPORT_SUPPLIER_ORDER } from '../../../api/downfileapi'
import { message } from 'antd'
import { useQuery } from '../../../tools/utilHooks'
import { jumpStateList } from '../hooks'
export type orderassuranceTabKey = '待发货' | '已完成' | '全部'
type RadioDict = {
  [x in orderassuranceTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}
interface orderCountsState {
  acceptedCount: number // 待验收订单个数
  processCount: number // 履约中订单个数
  waitCount: number // 待履约订单个数
}

interface CheckGroupParam {
  confirmState?: boolean
  cancelState?: boolean
  returnState?: boolean
  refuseState?: boolean
}
interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderassuranceTabKey // 当前选中tab的key值
  dataSource: any[]
  isTableLoading?: boolean
  orderCountsState: orderCountsState
  pagination: paginationOption
  searchParam: any
  checkGroupParam: CheckGroupParam
  selectedRows: any[]
  orderCountParam: any
  loading: boolean
  detailInfo: any
  customerOrderCodeList: any
  productList: any
  downLoadModal: boolean
  downLoadSelectedRowKeys: string[]
  downLoadModalLoading: false
  currentOrderId: string
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setOrderCountsState'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setSelectedRows'
  | 'setCheckGroupParamAction'
  | 'setOrderCountParam'
  | 'setLoadingAction'
  | 'setDetailInfoAction'
  | 'setCustomerOrderCodeListAction'
  | 'setProductListAction'
  | 'setDownLoadModalAciton'
  | 'setDownLoadSelectedRowKeysAction'
  | 'setDownLoadModalLoadingAction'
  | 'setCurrentOrderIdAciton'
interface Action {
  type: ActionType
  payload: any
}

const initialRadioDict: RadioDict = {
  待发货: {
    key: 'toAssure',
    value: '待发货(0)',
    keyName: '待发货',
    numMap: 'WAIT',
  },
  已完成: {
    key: 'finished',
    value: '已完成',
    keyName: '已完成',
    numMap: 'COMPLETE',
  },
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '',
  },
}
const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '全部',
  dataSource: [],
  isTableLoading: false,
  orderCountsState: {
    acceptedCount: 0,
    processCount: 0,
    waitCount: 0,
  },
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  checkGroupParam: {
    confirmState: false,
    cancelState: false,
    returnState: false,
    refuseState: false,
  },
  orderCountParam: {},
  loading: false,
  detailInfo: [],
  customerOrderCodeList: [],
  productList: [],
  downLoadModal: false,
  downLoadSelectedRowKeys: [],
  downLoadModalLoading: false,
  currentOrderId: '',
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setOrderCountsState':
      newstate.orderCountsState = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setOrderCountParam':
      newstate.orderCountParam = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setCheckGroupParamAction':
      newstate.checkGroupParam = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setCustomerOrderCodeListAction':
      newstate.customerOrderCodeList = action.payload
      return newstate
    case 'setProductListAction':
      newstate.productList = action.payload
      return newstate
    case 'setDownLoadModalAciton':
      newstate.downLoadModal = action.payload
      return newstate
    case 'setDownLoadSelectedRowKeysAction':
      newstate.downLoadSelectedRowKeys = action.payload
      return newstate
    case 'setDownLoadModalLoadingAction':
      newstate.downLoadModalLoading = action.payload
      return newstate
    case 'setCurrentOrderIdAciton':
      newstate.currentOrderId = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

const setOrderCountParam = (val: any): Action => ({
  type: 'setOrderCountParam',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: orderassuranceTabKey): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

const setCheckGroupParamAction = (val: CheckGroupParam): Action => ({
  type: 'setCheckGroupParamAction',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: paginationOption): Action => ({
  type: 'setDataSource',
  payload: val,
})
/**
 * 设置订单数据相关
 * @param val
 * @returns
 */
const setOrderCountsState = (val: orderCountsState): Action => ({
  type: 'setOrderCountsState',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

const setLoadingAction = (val: any): Action => ({
  type: 'setLoadingAction',
  payload: val,
})

const setDetailInfoAction = (val: any): Action => ({
  type: 'setDetailInfoAction',
  payload: val,
})

const setCustomerOrderCodeListAction = (val: any): Action => ({
  type: 'setCustomerOrderCodeListAction',
  payload: val,
})

const setProductListAction = (val: any): Action => ({
  type: 'setProductListAction',
  payload: val,
})

const setDownLoadModalAciton = (val: any): Action => ({
  type: 'setDownLoadModalAciton',
  payload: val,
})

const setDownLoadSelectedRowKeysAction = (val: any): Action => ({
  type: 'setDownLoadSelectedRowKeysAction',
  payload: val,
})

const setDownLoadModalLoadingAction = (val: any): Action => ({
  type: 'setDownLoadModalLoadingAction',
  payload: val,
})

const setCurrentOrderIdAciton = (val: any): Action => ({
  type: 'setCurrentOrderIdAciton',
  payload: val,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const listState = query.get('listState') || ''
  const tab = query.get('tab') || ''
  const confirmStateParam = query.get('confirmState') || ''
  const {
    checkedRadioKey,
    currentRadioDict,
    dataSource: dateSource,
    isTableLoading,
    orderCountsState,
    pagination,
    searchParam,
    selectedRows,
    checkGroupParam,
    orderCountParam,
    detailInfo,
    downLoadSelectedRowKeys,
    productList,
    currentOrderId,
  } = state
  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
    handleNewOrderListRequest({
      ...searchParam,
      ...initialState.checkGroupParam,
      scpShipStatus: (currentRadioDict as any)?.[key].numMap,
      pageNo: 1,
      pageSize: initialState.pagination.pagesize,
    })
  }
  const handleSearchClick = (value: any) => {
    handleNewOrderListRequest({
      ...value,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
    dispatch(setSearchParam(value))
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    handleNewOrderListRequest({
      ...searchParam,
      ...checkGroupParam,
      pageNo: page,
      pageSize: pageSize ?? pagination.pagesize,
    })
  }

  const getOrderCountsState = async () => {
    const res = await GET_ORDER_STATE_COUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderCountsState({ ...res.data }))
      // 当tab=all时，如果待发货数量>0，自动切换到待发货tab
      if (tab === 'all' && res.data.waitCount > 0) {
        dispatch(setCheckedRadioKey('待发货'))
        handleNewOrderListRequest({
          ...searchParam,
          ...initialState.checkGroupParam,
          scpShipStatus: currentRadioDict['待发货'].numMap,
          pageNo: 1,
          pageSize: initialState.pagination.pagesize,
        })
        return // 如果切换了tab，就不继续执行全部tab的请求
      }
      // 当tab=all且待发货数量=0时，请求全部tab的数据
      if (tab === 'all' && res.data.waitCount === 0) {
        dispatch(setCheckedRadioKey('全部'))
        handleNewOrderListRequest({
          ...searchParam,
          ...initialState.checkGroupParam,
          scpShipStatus: currentRadioDict['全部'].numMap,
          pageNo: 1,
          pageSize: initialState.pagination.pagesize,
        })
      }
    } else {
      message.warning(res.msg)
    }
  }
  async function handleNewOrderListRequest(
    param: Partial<SuppplierOrderParam>,
  ) {
    const { scpShipStatus, pageNo, pageSize } = param
    dispatch(setIsTableLoading(true))

    const currentCheckGroupParam = {
      confirmState: param.confirmState ? true : undefined,
      cancelState: param.cancelState ? true : undefined,
      returnState: param.returnState ? true : undefined,
      refuseState: param.refuseState ? true : undefined,
    }
    const currentScpShipStatus =
      scpShipStatus ?? currentRadioDict[checkedRadioKey].numMap
    const params = {
      ...param,
      ...currentCheckGroupParam,
      scpShipStatus: currentScpShipStatus,
    }
    dispatch(setOrderCountParam(params))
    getSupplierOrderCount({
      supplierId: getSupplierId(),
      ...params,
      pageNo: undefined,
      pageSize: undefined,
    })
    const res = await GET_SUPPLIER_ORDER_PAGE(params)
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDataSource(res.data.content))
      // 设置分页
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
      dispatch(
        setCheckGroupParamAction({
          ...currentCheckGroupParam,
        }),
      )
    } else {
      message.warning(res.msg)
    }
  }

  const handleTableRefresh = async () => {
    handleNewOrderListRequest({
      ...searchParam,
      ...initialState.checkGroupParam,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }
  // 首次加载页面时，获取订单数量
  useEffect(() => {
    if (jumpStateList.includes(listState as any)) {
      handleNewOrderListRequest({
        ...searchParam,
        scpShipStatus: currentRadioDict['待发货'].numMap,
        returnState: true,
        pageNo: 1,
        pageSize: initialState.pagination.pagesize,
      })
      dispatch(setCheckedRadioKey('待发货'))
      getOrderCountsState()
    } else if (tab === 'waitship') {
      // 待发货tab：发货状态=待发货
      dispatch(setCheckedRadioKey('待发货'))
      const checkGroupParamFromUrl: CheckGroupParam = {
        ...initialState.checkGroupParam,
      }
      // 处理confirmState参数：如果URL中有confirmState=true，则筛选"待确认"标签的订单
      if (confirmStateParam === 'true') {
        checkGroupParamFromUrl.confirmState = true
      }
      dispatch(setCheckGroupParamAction(checkGroupParamFromUrl))
      handleNewOrderListRequest({
        ...searchParam,
        ...checkGroupParamFromUrl,
        scpShipStatus: currentRadioDict['待发货'].numMap,
        pageNo: 1,
        pageSize: initialState.pagination.pagesize,
      })
      getOrderCountsState()
    } else if (tab === 'all') {
      // 全部tab：先获取订单数量，然后根据数量判断是否切换到待发货tab
      // getOrderCountsState中会根据数量判断是否切换tab并请求数据
      getOrderCountsState()
    } else {
      handleNewOrderListRequest({
        ...searchParam,
        ...checkGroupParam,
        pageNo: 1,
        pageSize: initialState.pagination.pagesize,
      })
      getOrderCountsState()
    }

    // eslint-disable-next-line
  }, [])

  // orderCountsState 发生变化的时候，带动tab数据变化。
  useEffect(() => {
    getSupplierOrderCount({
      supplierId: getSupplierId(),
      ...orderCountParam,
      pageNo: undefined,
      pageSize: undefined,
    })
    // eslint-disable-next-line
  }, [orderCountsState])
  const getSupplierOrderCount = async (params: any) => {
    const res = await GET_TAB_SUPPLIER_ORDERCOUNT(params)
    if (isResponseCodeSuccess(res.code)) {
      const newRadioDict = { ...currentRadioDict }
      newRadioDict['待发货'].value = `待发货(${countToStr(res.data.waitCount)})`

      dispatch(setCurrentRadioDict(newRadioDict))
    }
  }
  const setOrderState = (type: string) => {
    const currentCheckParam = { ...checkGroupParam }
    if (type === 'confirm') {
      currentCheckParam.confirmState =
        !currentCheckParam.confirmState || undefined
    } else if (type === 'cancel') {
      currentCheckParam.cancelState =
        !currentCheckParam.cancelState || undefined
    } else if (type === 'refuse') {
      currentCheckParam.refuseState =
        !currentCheckParam.refuseState || undefined
    } else {
      currentCheckParam.returnState =
        !currentCheckParam.returnState || undefined
    }
    handleNewOrderListRequest({
      ...searchParam,
      ...currentCheckParam,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }
  const exportFile = async () => {
    const data = {
      ids: selectedRows,
      query: {
        ...checkGroupParam,
        scpShipStatus: currentRadioDict[checkedRadioKey].numMap,
        userId: getUserId(),
        supplierId: getSupplierId(),
        ...searchParam,
      },
    }
    const res = await EXPORT_SUPPLIER_ORDER({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }
  const handleTableChangeCheck = (selectedRowKeys: any) => {
    dispatch(setSelectedRows(selectedRowKeys))
  }

  // 下载配货单
  const downloadOrder = async (record: any) => {
    dispatch(setCurrentOrderIdAciton(record.id))
    getDetailInfo(record)
  }

  const getDetailInfo = async (record: any) => {
    dispatch(setLoadingAction(true))
    const res = await GET_SUPPLINER_ORDER_DETAIL({
      id: record.id,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDetailInfoAction(res.data))
      const resData = res.data
      const detailedProductDTOList: any = resData.detailedProductDTOList
      const customerOrderCodeList = resData.customerOrderCode
        ?.split(',')
        .map((code) => ({ customerOrderCode: code.trim() }))
      dispatch(setCustomerOrderCodeListAction(customerOrderCodeList))
      dispatch(setProductListAction(detailedProductDTOList))
      isOpenDownLoadModal(
        res.data,
        detailedProductDTOList,
        customerOrderCodeList,
        record.id,
      )
    } else {
      message.warning(res.msg)
    }
    dispatch(setLoadingAction(false))
  }

  const isOpenDownLoadModal = (
    detailInfo: any,
    productList: any,
    customerOrderCodeList: any,
    id: string,
  ) => {
    if (customerOrderCodeList.length > 1) {
      dispatch(setDownLoadModalAciton(true))
    } else {
      const newCodeList = customerOrderCodeList.map(
        (item: { customerOrderCode: any }) => item.customerOrderCode,
      )
      directExportNote(detailInfo, productList, newCodeList, id)
    }
  }

  const handleDownLoadTableCheck = (selectedRowKeys: any) => {
    dispatch(setDownLoadSelectedRowKeysAction(selectedRowKeys))
  }

  // 直接导出配货单

  const directExportNote = async (
    detailInfo: any,
    productList: any,
    customerOrderCodeList: string[],
    orderId: string,
  ) => {
    const unshipped = productList.filter(
      (item: { waitQty: number; shipQty: number }) =>
        (item.waitQty > 0 && item.shipQty === 0) ||
        (item.waitQty > 0 && item.shipQty > 0),
    )
    const params = {
      directShipment: detailInfo.directShipment,
      orderId: orderId,
      customerOrderCodes: customerOrderCodeList.join(','),
      productCodeList: unshipped.map((item: any) => item.productCode),
      ids: unshipped.map((item: any) => item.id),
    }
    // 调用导出函数
    await EXPORT_SELECT_ORDER_DETAIL(params)
  }

  // 导出配货单
  const exportNote = async () => {
    dispatch(setDownLoadModalLoadingAction(true))
    const unshipped = productList.filter(
      (item: { waitQty: number; shipQty: number }) =>
        (item.waitQty > 0 && item.shipQty === 0) ||
        (item.waitQty > 0 && item.shipQty > 0),
    )
    const params = {
      directShipment: detailInfo.directShipment,
      orderId: currentOrderId,
      customerOrderCodes: downLoadSelectedRowKeys.join(','),
      productCodeList:
        detailInfo.directShipment && detailInfo.customerOrderCode
          ? unshipped.map((item: any) => item.productCode)
          : [],
      ids: unshipped.map((item: any) => item.id),
    }

    // 调用导出函数
    await EXPORT_SELECT_ORDER_DETAIL(params)
    dispatch(setDownLoadModalLoadingAction(false))
    dispatch(setDownLoadModalAciton(false))
  }

  const downLoadModalCancel = () => {
    dispatch(setDownLoadModalAciton(false))
  }

  const downLoadModalOk = () => {
    if (!downLoadSelectedRowKeys.length) {
      message.warning('请先选择订单号')
      return
    } else if (downLoadSelectedRowKeys.length >= 200) {
      message.warning('每次最多选择200条客户订单导出')
      return
    }
    exportNote()
  }
  return {
    checkedRadioKey,
    currentRadioDict,
    dateSource,
    isTableLoading,
    pagination,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    setOrderState,
    state,
    exportFile,
    handleTableChangeCheck,
    downloadOrder,
    handleDownLoadTableCheck,
    downLoadModalCancel,
    downLoadModalOk,
  }
}
import { useEffect, useReducer } from 'react'
import {
  countToStr,
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../../tools/util'
import {
  EXPORT_SELECT_ORDER_DETAIL,
  GET_ORDER_STATE_COUNT,
  GET_SUPPLIER_ORDER_PAGE,
  GET_SUPPLINER_ORDER_DETAIL,
  GET_TAB_SUPPLIER_ORDERCOUNT,
  SuppplierOrderParam,
} from '../../../api/orderManage'
import { EXPORT_SUPPLIER_ORDER } from '../../../api/downfileapi'
import { message } from 'antd'
import { useQuery } from '../../../tools/utilHooks'
import { jumpStateList } from '../hooks'
export type orderassuranceTabKey = '待发货' | '已完成' | '全部'
type RadioDict = {
  [x in orderassuranceTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}
interface orderCountsState {
  acceptedCount: number // 待验收订单个数
  processCount: number // 履约中订单个数
  waitCount: number // 待履约订单个数
}

interface CheckGroupParam {
  confirmState?: boolean
  cancelState?: boolean
  returnState?: boolean
  refuseState?: boolean
}
interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderassuranceTabKey // 当前选中tab的key值
  dataSource: any[]
  isTableLoading?: boolean
  orderCountsState: orderCountsState
  pagination: paginationOption
  searchParam: any
  checkGroupParam: CheckGroupParam
  selectedRows: any[]
  orderCountParam: any
  loading: boolean
  detailInfo: any
  customerOrderCodeList: any
  productList: any
  downLoadModal: boolean
  downLoadSelectedRowKeys: string[]
  downLoadModalLoading: false
  currentOrderId: string
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setOrderCountsState'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setSelectedRows'
  | 'setCheckGroupParamAction'
  | 'setOrderCountParam'
  | 'setLoadingAction'
  | 'setDetailInfoAction'
  | 'setCustomerOrderCodeListAction'
  | 'setProductListAction'
  | 'setDownLoadModalAciton'
  | 'setDownLoadSelectedRowKeysAction'
  | 'setDownLoadModalLoadingAction'
  | 'setCurrentOrderIdAciton'
interface Action {
  type: ActionType
  payload: any
}

const initialRadioDict: RadioDict = {
  待发货: {
    key: 'toAssure',
    value: '待发货(0)',
    keyName: '待发货',
    numMap: 'WAIT',
  },
  已完成: {
    key: 'finished',
    value: '已完成',
    keyName: '已完成',
    numMap: 'COMPLETE',
  },
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '',
  },
}
const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '全部',
  dataSource: [],
  isTableLoading: false,
  orderCountsState: {
    acceptedCount: 0,
    processCount: 0,
    waitCount: 0,
  },
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  checkGroupParam: {
    confirmState: false,
    cancelState: false,
    returnState: false,
    refuseState: false,
  },
  orderCountParam: {},
  loading: false,
  detailInfo: [],
  customerOrderCodeList: [],
  productList: [],
  downLoadModal: false,
  downLoadSelectedRowKeys: [],
  downLoadModalLoading: false,
  currentOrderId: '',
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setOrderCountsState':
      newstate.orderCountsState = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setOrderCountParam':
      newstate.orderCountParam = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setCheckGroupParamAction':
      newstate.checkGroupParam = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setCustomerOrderCodeListAction':
      newstate.customerOrderCodeList = action.payload
      return newstate
    case 'setProductListAction':
      newstate.productList = action.payload
      return newstate
    case 'setDownLoadModalAciton':
      newstate.downLoadModal = action.payload
      return newstate
    case 'setDownLoadSelectedRowKeysAction':
      newstate.downLoadSelectedRowKeys = action.payload
      return newstate
    case 'setDownLoadModalLoadingAction':
      newstate.downLoadModalLoading = action.payload
      return newstate
    case 'setCurrentOrderIdAciton':
      newstate.currentOrderId = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

const setOrderCountParam = (val: any): Action => ({
  type: 'setOrderCountParam',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: orderassuranceTabKey): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

const setCheckGroupParamAction = (val: CheckGroupParam): Action => ({
  type: 'setCheckGroupParamAction',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: paginationOption): Action => ({
  type: 'setDataSource',
  payload: val,
})
/**
 * 设置订单数据相关
 * @param val
 * @returns
 */
const setOrderCountsState = (val: orderCountsState): Action => ({
  type: 'setOrderCountsState',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

const setLoadingAction = (val: any): Action => ({
  type: 'setLoadingAction',
  payload: val,
})

const setDetailInfoAction = (val: any): Action => ({
  type: 'setDetailInfoAction',
  payload: val,
})

const setCustomerOrderCodeListAction = (val: any): Action => ({
  type: 'setCustomerOrderCodeListAction',
  payload: val,
})

const setProductListAction = (val: any): Action => ({
  type: 'setProductListAction',
  payload: val,
})

const setDownLoadModalAciton = (val: any): Action => ({
  type: 'setDownLoadModalAciton',
  payload: val,
})

const setDownLoadSelectedRowKeysAction = (val: any): Action => ({
  type: 'setDownLoadSelectedRowKeysAction',
  payload: val,
})

const setDownLoadModalLoadingAction = (val: any): Action => ({
  type: 'setDownLoadModalLoadingAction',
  payload: val,
})

const setCurrentOrderIdAciton = (val: any): Action => ({
  type: 'setCurrentOrderIdAciton',
  payload: val,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const listState = query.get('listState') || ''
  const tab = query.get('tab') || ''
  const confirmStateParam = query.get('confirmState') || ''
  const {
    checkedRadioKey,
    currentRadioDict,
    dataSource: dateSource,
    isTableLoading,
    orderCountsState,
    pagination,
    searchParam,
    selectedRows,
    checkGroupParam,
    orderCountParam,
    detailInfo,
    downLoadSelectedRowKeys,
    productList,
    currentOrderId,
  } = state
  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
    handleNewOrderListRequest({
      ...searchParam,
      ...initialState.checkGroupParam,
      scpShipStatus: (currentRadioDict as any)?.[key].numMap,
      pageNo: 1,
      pageSize: initialState.pagination.pagesize,
    })
  }
  const handleSearchClick = (value: any) => {
    handleNewOrderListRequest({
      ...value,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
    dispatch(setSearchParam(value))
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    handleNewOrderListRequest({
      ...searchParam,
      ...checkGroupParam,
      pageNo: page,
      pageSize: pageSize ?? pagination.pagesize,
    })
  }

  const getOrderCountsState = async () => {
    const res = await GET_ORDER_STATE_COUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderCountsState({ ...res.data }))
      // 当tab=all时，如果待发货数量>0，自动切换到待发货tab
      if (tab === 'all' && res.data.waitCount > 0) {
        dispatch(setCheckedRadioKey('待发货'))
        handleNewOrderListRequest({
          ...searchParam,
          ...initialState.checkGroupParam,
          scpShipStatus: currentRadioDict['待发货'].numMap,
          pageNo: 1,
          pageSize: initialState.pagination.pagesize,
        })
        return // 如果切换了tab，就不继续执行全部tab的请求
      }
      // 当tab=all且待发货数量=0时，请求全部tab的数据
      if (tab === 'all' && res.data.waitCount === 0) {
        dispatch(setCheckedRadioKey('全部'))
        handleNewOrderListRequest({
          ...searchParam,
          ...initialState.checkGroupParam,
          scpShipStatus: currentRadioDict['全部'].numMap,
          pageNo: 1,
          pageSize: initialState.pagination.pagesize,
        })
      }
    } else {
      message.warning(res.msg)
    }
  }
  async function handleNewOrderListRequest(
    param: Partial<SuppplierOrderParam>,
  ) {
    const { scpShipStatus, pageNo, pageSize } = param
    dispatch(setIsTableLoading(true))

    const currentCheckGroupParam = {
      confirmState: param.confirmState ? true : undefined,
      cancelState: param.cancelState ? true : undefined,
      returnState: param.returnState ? true : undefined,
      refuseState: param.refuseState ? true : undefined,
    }
    const currentScpShipStatus =
      scpShipStatus ?? currentRadioDict[checkedRadioKey].numMap
    const params = {
      ...param,
      ...currentCheckGroupParam,
      scpShipStatus: currentScpShipStatus,
    }
    dispatch(setOrderCountParam(params))
    getSupplierOrderCount({
      supplierId: getSupplierId(),
      ...params,
      pageNo: undefined,
      pageSize: undefined,
    })
    const res = await GET_SUPPLIER_ORDER_PAGE(params)
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDataSource(res.data.content))
      // 设置分页
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
      dispatch(
        setCheckGroupParamAction({
          ...currentCheckGroupParam,
        }),
      )
    } else {
      message.warning(res.msg)
    }
  }

  const handleTableRefresh = async () => {
    handleNewOrderListRequest({
      ...searchParam,
      ...initialState.checkGroupParam,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }
  // 首次加载页面时，获取订单数量
  useEffect(() => {
    if (jumpStateList.includes(listState as any)) {
      handleNewOrderListRequest({
        ...searchParam,
        scpShipStatus: currentRadioDict['待发货'].numMap,
        returnState: true,
        pageNo: 1,
        pageSize: initialState.pagination.pagesize,
      })
      dispatch(setCheckedRadioKey('待发货'))
      getOrderCountsState()
    } else if (tab === 'waitship') {
      // 待发货tab：发货状态=待发货
      dispatch(setCheckedRadioKey('待发货'))
      const checkGroupParamFromUrl: CheckGroupParam = {
        ...initialState.checkGroupParam,
      }
      // 处理confirmState参数：如果URL中有confirmState=true，则筛选"待确认"标签的订单
      if (confirmStateParam === 'true') {
        checkGroupParamFromUrl.confirmState = true
      }
      dispatch(setCheckGroupParamAction(checkGroupParamFromUrl))
      handleNewOrderListRequest({
        ...searchParam,
        ...checkGroupParamFromUrl,
        scpShipStatus: currentRadioDict['待发货'].numMap,
        pageNo: 1,
        pageSize: initialState.pagination.pagesize,
      })
      getOrderCountsState()
    } else if (tab === 'all') {
      // 全部tab：先获取订单数量，然后根据数量判断是否切换到待发货tab
      // getOrderCountsState中会根据数量判断是否切换tab并请求数据
      getOrderCountsState()
    } else {
      handleNewOrderListRequest({
        ...searchParam,
        ...checkGroupParam,
        pageNo: 1,
        pageSize: initialState.pagination.pagesize,
      })
      getOrderCountsState()
    }

    // eslint-disable-next-line
  }, [])

  // orderCountsState 发生变化的时候，带动tab数据变化。
  useEffect(() => {
    getSupplierOrderCount({
      supplierId: getSupplierId(),
      ...orderCountParam,
      pageNo: undefined,
      pageSize: undefined,
    })
    // eslint-disable-next-line
  }, [orderCountsState])
  const getSupplierOrderCount = async (params: any) => {
    const res = await GET_TAB_SUPPLIER_ORDERCOUNT(params)
    if (isResponseCodeSuccess(res.code)) {
      const newRadioDict = { ...currentRadioDict }
      newRadioDict['待发货'].value = `待发货(${countToStr(res.data.waitCount)})`

      dispatch(setCurrentRadioDict(newRadioDict))
    }
  }
  const setOrderState = (type: string) => {
    const currentCheckParam = { ...checkGroupParam }
    if (type === 'confirm') {
      currentCheckParam.confirmState =
        !currentCheckParam.confirmState || undefined
    } else if (type === 'cancel') {
      currentCheckParam.cancelState =
        !currentCheckParam.cancelState || undefined
    } else if (type === 'refuse') {
      currentCheckParam.refuseState =
        !currentCheckParam.refuseState || undefined
    } else {
      currentCheckParam.returnState =
        !currentCheckParam.returnState || undefined
    }
    handleNewOrderListRequest({
      ...searchParam,
      ...currentCheckParam,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }
  const exportFile = async () => {
    const data = {
      ids: selectedRows,
      query: {
        ...checkGroupParam,
        scpShipStatus: currentRadioDict[checkedRadioKey].numMap,
        userId: getUserId(),
        supplierId: getSupplierId(),
        ...searchParam,
      },
    }
    const res = await EXPORT_SUPPLIER_ORDER({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }
  const handleTableChangeCheck = (selectedRowKeys: any) => {
    dispatch(setSelectedRows(selectedRowKeys))
  }

  // 下载配货单
  const downloadOrder = async (record: any) => {
    dispatch(setCurrentOrderIdAciton(record.id))
    getDetailInfo(record)
  }

  const getDetailInfo = async (record: any) => {
    dispatch(setLoadingAction(true))
    const res = await GET_SUPPLINER_ORDER_DETAIL({
      id: record.id,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDetailInfoAction(res.data))
      const resData = res.data
      const detailedProductDTOList: any = resData.detailedProductDTOList
      const customerOrderCodeList = resData.customerOrderCode
        ?.split(',')
        .map((code) => ({ customerOrderCode: code.trim() }))
      dispatch(setCustomerOrderCodeListAction(customerOrderCodeList))
      dispatch(setProductListAction(detailedProductDTOList))
      isOpenDownLoadModal(
        res.data,
        detailedProductDTOList,
        customerOrderCodeList,
        record.id,
      )
    } else {
      message.warning(res.msg)
    }
    dispatch(setLoadingAction(false))
  }

  const isOpenDownLoadModal = (
    detailInfo: any,
    productList: any,
    customerOrderCodeList: any,
    id: string,
  ) => {
    if (customerOrderCodeList.length > 1) {
      dispatch(setDownLoadModalAciton(true))
    } else {
      const newCodeList = customerOrderCodeList.map(
        (item: { customerOrderCode: any }) => item.customerOrderCode,
      )
      directExportNote(detailInfo, productList, newCodeList, id)
    }
  }

  const handleDownLoadTableCheck = (selectedRowKeys: any) => {
    dispatch(setDownLoadSelectedRowKeysAction(selectedRowKeys))
  }

  // 直接导出配货单

  const directExportNote = async (
    detailInfo: any,
    productList: any,
    customerOrderCodeList: string[],
    orderId: string,
  ) => {
    const unshipped = productList.filter(
      (item: { waitQty: number; shipQty: number }) =>
        (item.waitQty > 0 && item.shipQty === 0) ||
        (item.waitQty > 0 && item.shipQty > 0),
    )
    const params = {
      directShipment: detailInfo.directShipment,
      orderId: orderId,
      customerOrderCodes: customerOrderCodeList.join(','),
      productCodeList: unshipped.map((item: any) => item.productCode),
      ids: unshipped.map((item: any) => item.id),
    }
    // 调用导出函数
    await EXPORT_SELECT_ORDER_DETAIL(params)
  }

  // 导出配货单
  const exportNote = async () => {
    dispatch(setDownLoadModalLoadingAction(true))
    const unshipped = productList.filter(
      (item: { waitQty: number; shipQty: number }) =>
        (item.waitQty > 0 && item.shipQty === 0) ||
        (item.waitQty > 0 && item.shipQty > 0),
    )
    const params = {
      directShipment: detailInfo.directShipment,
      orderId: currentOrderId,
      customerOrderCodes: downLoadSelectedRowKeys.join(','),
      productCodeList:
        detailInfo.directShipment && detailInfo.customerOrderCode
          ? unshipped.map((item: any) => item.productCode)
          : [],
      ids: unshipped.map((item: any) => item.id),
    }

    // 调用导出函数
    await EXPORT_SELECT_ORDER_DETAIL(params)
    dispatch(setDownLoadModalLoadingAction(false))
    dispatch(setDownLoadModalAciton(false))
  }

  const downLoadModalCancel = () => {
    dispatch(setDownLoadModalAciton(false))
  }

  const downLoadModalOk = () => {
    if (!downLoadSelectedRowKeys.length) {
      message.warning('请先选择订单号')
      return
    } else if (downLoadSelectedRowKeys.length >= 200) {
      message.warning('每次最多选择200条客户订单导出')
      return
    }
    exportNote()
  }
  return {
    checkedRadioKey,
    currentRadioDict,
    dateSource,
    isTableLoading,
    pagination,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    setOrderState,
    state,
    exportFile,
    handleTableChangeCheck,
    downloadOrder,
    handleDownLoadTableCheck,
    downLoadModalCancel,
    downLoadModalOk,
  }
}
